/* nw-mega-menu — hover-open behaviour with 150ms delay.
   Applies only on desktop (≥990px). Mobile uses the menu-drawer.
   Preserves Dawn's keyboard click-to-toggle by listening for both. */
(() => {
  const OPEN_DELAY_MS = 150;
  const CLOSE_DELAY_MS = 220;
  const DESKTOP_MIN_PX = 990;

  const isDesktop = () => window.matchMedia(`(min-width: ${DESKTOP_MIN_PX}px)`).matches;

  const wireDetails = (details) => {
    if (details.dataset.nwHoverWired === 'true') return;
    details.dataset.nwHoverWired = 'true';

    let openTimer = null;
    let closeTimer = null;
    const summary = details.querySelector('summary');

    const open = () => {
      clearTimeout(closeTimer);
      if (details.open) return;
      details.open = true;
      details.setAttribute('data-nw-opened-by', 'hover');
    };

    const close = () => {
      clearTimeout(openTimer);
      if (!details.open) return;
      // Only auto-close if it was opened by hover. Click-opens stay until clicked again.
      if (details.dataset.nwOpenedBy !== 'hover') return;
      details.open = false;
      details.removeAttribute('data-nw-opened-by');
    };

    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, OPEN_DELAY_MS);
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY_MS);
    });

    if (summary) {
      summary.addEventListener('click', () => {
        // User clicked — mark as click-opened so hover-leave doesn't auto-close it.
        // Use rAF so we read the post-click open state.
        requestAnimationFrame(() => {
          if (details.open) {
            details.setAttribute('data-nw-opened-by', 'click');
          } else {
            details.removeAttribute('data-nw-opened-by');
          }
        });
      });
    }
  };

  const wireAll = () => {
    document
      .querySelectorAll('header-menu details.mega-menu')
      .forEach(wireDetails);
  };

  // Close all open mega panels on Escape (Dawn handles focus return).
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((d) => {
      d.open = false;
      d.removeAttribute('data-nw-opened-by');
    });
  });

  // Close on click-outside (only when opened by hover OR click — both should close).
  document.addEventListener('click', (e) => {
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((d) => {
      if (d.contains(e.target)) return;
      d.open = false;
      d.removeAttribute('data-nw-opened-by');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
})();
